/**
 * @flow
 */
'use strict';

export const raisonPrincipaleCodes = [
{"code":"1st exam"},
{"code":"2nd advice"},
{"code":"Abipa"},
{"code":"Abrasion cornéenne"},
{"code":"Alcoa"},
{"code":"Allergy"},
{"code":"Anisocoria"},
{"code":"Aviation entry"},
{"code":"Blackout"},
{"code":"Blinking excessif"},
{"code":"Blinking"},
{"code":"Broken frame"},
{"code":"Broken glasses"},
{"code":"Cataract post-op 1 day"},
{"code":"Cataract post-op 1 month"},
{"code":"Cataract post-op 1 week"},
{"code":"Cataract"},
{"code":"Cephalalgia"},
{"code":"Chalazion"},
{"code":"Change frame"},
{"code":"Change glasses"},
{"code":"Change in vision"},
{"code":"Check-up"},
{"code":"CL problem"},
{"code":"CL renewal"},
{"code":"CL trial"},
{"code":"CL verification"},
{"code":"CL verify"},
{"code":"Conjunctivitis"},
{"code":"Control IOP"},
{"code":"Control Lasik"},
{"code":"Control Rx"},
{"code":"Control"},
{"code":"Cyclo"},
{"code":"Decreased vision"},
{"code":"Dent"},
{"code":"Deviation"},
{"code":"Difficulty computer"},
{"code":"Difficulty concentration"},
{"code":"Difficulty DV"},
{"code":"Difficulty focus"},
{"code":"Difficulty glasses"},
{"code":"Difficulty NV"},
{"code":"Difficulty reading"},
{"code":"Difficulty school"},
{"code":"Dilatation (myopie OU)"},
{"code":"Dilatation diabetis"},
{"code":"Dilatation"},
{"code":"Diplopia"},
{"code":"Disccomfort"},
{"code":"Diving mask"},
{"code":"Dizziness"},
{"code":"Dots black"},
{"code":"Dots white"},
{"code":"DV Decrease"},
{"code":"DV Decreased"},
{"code":"Emergency"},
{"code":"Evaluation myopia"},
{"code":"Exam diabetis"},
{"code":"Exam dilated"},
{"code":"Exam full"},
{"code":"Exam partial"},
{"code":"Exam post-cataract"},
{"code":"Eye dry"},
{"code":"Eye red"},
{"code":"Eye shifted"},
{"code":"Eye swollen"},
{"code":"Eye tingle"},
{"code":"Eye watery"},
{"code":"Eyelid burned"},
{"code":"Eyelid drooping"},
{"code":"Eyelid edema"},
{"code":"Eyelid glued"},
{"code":"Eyelid shifted"},
{"code":"Eyelid swollen"},
{"code":"Eyes ache"},
{"code":"Eyes burning sensation"},
{"code":"Eyes dry"},
{"code":"Eyes iritated"},
{"code":"Eyes red"},
{"code":"Eyes secretion"},
{"code":"Eyes sensitive"},
{"code":"Eyes sting"},
{"code":"Eyes swollen"},
{"code":"Eyes tired"},
{"code":"Eyes Watering"},
{"code":"Falling"},
{"code":"Fatigue DV"},
{"code":"Fatigue ocular"},
{"code":"Fatigue visuelle"},
{"code":"Flash"},
{"code":"Floaters"},
{"code":"Focus difficulty"},
{"code":"Follow-up amblyopie"},
{"code":"Follow-up CL"},
{"code":"Follow-up cornea"},
{"code":"Follow-up dilation"},
{"code":"Follow-up dry eyes"},
{"code":"Follow-up emergency"},
{"code":"Follow-up HTO"},
{"code":"Follow-up keratitis"},
{"code":"Follow-up Lasik"},
{"code":"Follow-up myopia"},
{"code":"Follow-up ophthalmologist"},
{"code":"Follow-up post-op"},
{"code":"Follow-up retina"},
{"code":"Follow-up Rx"},
{"code":"Follow-up suspect glaucome"},
{"code":"Follow-up"},
{"code":"Foreign body"},
{"code":"Frame broken"},
{"code":"Frame damaged"},
{"code":"Frame to little"},
{"code":"FV blurred"},
{"code":"FV difficulty at night"},
{"code":"FV difficulty"},
{"code":"FV ok sans Rx"},
{"code":"Glare"},
{"code":"Glasses broken"},
{"code":"Glasses computer"},
{"code":"Glasses damaged"},
{"code":"Glasses damaged"},
{"code":"Glasses DV"},
{"code":"Glasses lost"},
{"code":"Glasses new"},
{"code":"Glasses problem"},
{"code":"Glasses security"},
{"code":"Glasses sport"},
{"code":"Glasses stolen"},
{"code":"Glasses sun"},
{"code":"Halos"},
{"code":"Headache"},
{"code":"Infection followup"},
{"code":"Infection"},
{"code":"Interest CL"},
{"code":"IOP/HRT"},
{"code":"Irritation"},
{"code":"Itching"},
{"code":"Lines black"},
{"code":"Lines distorted"},
{"code":"Lost eyeglasses"},
{"code":"Lost lens"},
{"code":"Lost Rx"},
{"code":"Migraine"},
{"code":"Mydriasis"},
{"code":"Numbness"},
{"code":"NV blurred"},
{"code":"NV Blurry"},
{"code":"NV Decrease"},
{"code":"NV decreased"},
{"code":"NV Decreased"},
{"code":"NV difficulty"},
{"code":"OD blurred"},
{"code":"Order contacts"},
{"code":"Order glasses"},
{"code":"Pain"},
{"code":"Parker"},
{"code":"Photophobia"},
{"code":"Post op lasik"},
{"code":"Pressure"},
{"code":"Prolapse"},
{"code":"Questions"},
{"code":"Recall"},
{"code":"Redness"},
{"code":"Reference MD"},
{"code":"Reference ophthalmologist"},
{"code":"Referral"},
{"code":"Renew CL"},
{"code":"Routine"},
{"code":"Rubs eyes"},
{"code":"Rx security"},
{"code":"Sailing"},
{"code":"Scan HRT"},
{"code":"Scratched cornea"},
{"code":"Screening diabetis"},
{"code":"Screening glaucoma"},
{"code":"Screening"},
{"code":"Sees black bars"},
{"code":"Sees double"},
{"code":"Sensation burning"},
{"code":"Sensation sand"},
{"code":"Sensitivity to light"},
{"code":"Sent by school"},
{"code":"Sparkles"},
{"code":"Spots black"},
{"code":"Spots red"},
{"code":"Squinting"},
{"code":"Strabismus"},
{"code":"Suspect glaucome"},
{"code":"Suspect strabismus"},
{"code":"Swollen eyelids"},
{"code":"Trauma"},
{"code":"Trial CL"},
{"code":"Trial progressive"},
{"code":"Verify pupil"},
{"code":"Verify retina"},
{"code":"Verify Rx"},
{"code":"Violonist"},
{"code":"Vision blurred"},
{"code":"Vision difficulty at night"},
{"code":"Vision loss"},
{"code":"Vision ok with Rx"},
{"code":"Vision ok"},
{"code":"Vision stable"},
{"code":"Vision variable"},
{"code":"Visual field loss"},
{"code":"Visual field"},
{"code":"Wants 2nd advice"},
{"code":"Wants CL"},
{"code":"Wants new frame"},
{"code":"Wants Referral ophthalmologist"},
{"code":"Wants solar"},
]
